module.exports = __webpack_public_path__ + "img/excalibur.e6cd2a12.png";